import { forwardRef } from 'react';
import '../../styles/Buttons.css';
import { Button } from 'react-bootstrap';

interface TableBaseButtonProps {
  onClick: () => void;
  variant?: string;
  buttonText: string;
  className?: string;
  ref?: React.Ref<HTMLButtonElement>;
  onKeyDown?: (e: React.KeyboardEvent<HTMLButtonElement>) => void;
}

const TableBaseButton = forwardRef<HTMLButtonElement, TableBaseButtonProps>(
  ({ onClick, variant, buttonText, className, onKeyDown }, ref) => {
    return (
      <Button
        variant={variant}
        size="sm"
        className={`rounded-pill ${className}`}
        ref={ref}
        onClick={onClick}
        type="button"
        onKeyDown={onKeyDown}
      >
        {buttonText}
      </Button>
    );
  }
);

TableBaseButton.displayName = 'TableBaseButton';
export default TableBaseButton;
